import request from '@/utils/request';

//短信模板列表
export function getSmsList(values) {
  return request('/sms/querySmsTemplateList', {
    method: 'POST',
    data: values,
  });
}
//删除短息模板列表
export function deleteTempMsg(values) {
  return request('/sms/deleteTempMsg', {
    method: 'POST',
    data: values,
  });
}
